// extracted by mini-css-extract-plugin
export default {"About":"About_About__bDiiU","content":"About_content__-li09"};